/**
 * @flow
 * @relayHash 9d8c8213429df244bee3b3f889937e40
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobHistory_organization$ref = any;
type JobHistory_statusTypes$ref = any;
type OrganizationDetailsPending_organization$ref = any;
type OrganizationDetails_organization$ref = any;
type OrganizationStaff_organization$ref = any;
export type OrganizationDetailsPageQueryVariables = {|
  id: string,
  first?: ?number,
  orderBy?: ?string,
  after?: ?string,
|};
export type OrganizationDetailsPageQueryResponse = {|
  +organization: ?{|
    +name: string,
    +status: ?string,
  |},
  +jobStatus: ?{|
    +$fragmentRefs: JobHistory_statusTypes$ref
  |},
  +$fragmentRefs: JobHistory_organization$ref & OrganizationStaff_organization$ref & OrganizationDetails_organization$ref & OrganizationDetailsPending_organization$ref,
|};
export type OrganizationDetailsPageQuery = {|
  variables: OrganizationDetailsPageQueryVariables,
  response: OrganizationDetailsPageQueryResponse,
|};
*/


/*
query OrganizationDetailsPageQuery(
  $id: ID!
  $first: Int
  $orderBy: String
  $after: String
) {
  ...JobHistory_organization_2V0O2E
  ...OrganizationStaff_organization_2V0O2E
  ...OrganizationDetails_organization_1Bmzm5
  ...OrganizationDetailsPending_organization_1Bmzm5
  organization(id: $id) {
    name
    status
    id
  }
  jobStatus: __type(name: "JobStatus") {
    ...JobHistory_statusTypes
  }
}

fragment JobHistory_organization_2V0O2E on Query {
  organization(id: $id) {
    id
    jobs(first: $first, orderBy: $orderBy, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edgeCount
      edges {
        node {
          id
          contract {
            dateSignedByContractor
            id
          }
          totalValue
          staffCoordinator {
            representativeImageUrl
            fullName
            id
          }
          status
          name
          contractDate
          jobDeadline
          jobId
          dateCompleted
          currencyCode
        }
      }
    }
  }
}

fragment OrganizationStaff_organization_2V0O2E on Query {
  organization(id: $id) {
    name
    orgStaffs(first: $first, orderBy: $orderBy, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edgeCount
      edges {
        node {
          id
          fullName
          title
          representativeImageUrl
          phone
          city
          timezone
          user {
            email
            id
          }
        }
      }
    }
    id
  }
}

fragment OrganizationDetails_organization_1Bmzm5 on Query {
  organization(id: $id) {
    name
    address1
    city
    state
    zipcode
    country {
      name
    }
    website
    phone
    email
    representativeImageUrl
    id
  }
}

fragment OrganizationDetailsPending_organization_1Bmzm5 on Query {
  organization(id: $id) {
    id
    name
    address1
    city
    state
    website
    zipcode
    country {
      name
    }
    phone
    email
  }
}

fragment JobHistory_statusTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "JobStatus"
  }
],
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v8 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v9 = [
  (v6/*: any*/),
  (v7/*: any*/),
  (v1/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v11 = [
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "edgeCount",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "OrganizationDetailsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organization",
        "storageKey": null,
        "args": (v2/*: any*/),
        "concreteType": "OrgNode",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobStatus",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v5/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobHistory_statusTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "JobHistory_organization",
        "args": (v9/*: any*/)
      },
      {
        "kind": "FragmentSpread",
        "name": "OrganizationStaff_organization",
        "args": (v9/*: any*/)
      },
      {
        "kind": "FragmentSpread",
        "name": "OrganizationDetails_organization",
        "args": (v2/*: any*/)
      },
      {
        "kind": "FragmentSpread",
        "name": "OrganizationDetailsPending_organization",
        "args": (v2/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OrganizationDetailsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organization",
        "storageKey": null,
        "args": (v2/*: any*/),
        "concreteType": "OrgNode",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobs",
            "storageKey": null,
            "args": (v11/*: any*/),
            "concreteType": "JobNodeConnection",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobNode",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dateSignedByContractor",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalValue",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "staffCoordinator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "contractDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobDeadline",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dateCompleted",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currencyCode",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "orgStaffs",
            "storageKey": null,
            "args": (v11/*: any*/),
            "concreteType": "StaffNodeConnection",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "StaffNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StaffNode",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "timezone",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address1",
            "args": null,
            "storageKey": null
          },
          (v18/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zipcode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "country",
            "storageKey": null,
            "args": null,
            "concreteType": "Country",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "website",
            "args": null,
            "storageKey": null
          },
          (v17/*: any*/),
          (v19/*: any*/),
          (v15/*: any*/),
          (v4/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobStatus",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v5/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "enumValues",
            "storageKey": null,
            "args": null,
            "concreteType": "__EnumValue",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "OrganizationDetailsPageQuery",
    "id": null,
    "text": "query OrganizationDetailsPageQuery(\n  $id: ID!\n  $first: Int\n  $orderBy: String\n  $after: String\n) {\n  ...JobHistory_organization_2V0O2E\n  ...OrganizationStaff_organization_2V0O2E\n  ...OrganizationDetails_organization_1Bmzm5\n  ...OrganizationDetailsPending_organization_1Bmzm5\n  organization(id: $id) {\n    name\n    status\n    id\n  }\n  jobStatus: __type(name: \"JobStatus\") {\n    ...JobHistory_statusTypes\n  }\n}\n\nfragment JobHistory_organization_2V0O2E on Query {\n  organization(id: $id) {\n    id\n    jobs(first: $first, orderBy: $orderBy, after: $after) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      totalCount\n      edgeCount\n      edges {\n        node {\n          id\n          contract {\n            dateSignedByContractor\n            id\n          }\n          totalValue\n          staffCoordinator {\n            representativeImageUrl\n            fullName\n            id\n          }\n          status\n          name\n          contractDate\n          jobDeadline\n          jobId\n          dateCompleted\n          currencyCode\n        }\n      }\n    }\n  }\n}\n\nfragment OrganizationStaff_organization_2V0O2E on Query {\n  organization(id: $id) {\n    name\n    orgStaffs(first: $first, orderBy: $orderBy, after: $after) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      totalCount\n      edgeCount\n      edges {\n        node {\n          id\n          fullName\n          title\n          representativeImageUrl\n          phone\n          city\n          timezone\n          user {\n            email\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment OrganizationDetails_organization_1Bmzm5 on Query {\n  organization(id: $id) {\n    name\n    address1\n    city\n    state\n    zipcode\n    country {\n      name\n    }\n    website\n    phone\n    email\n    representativeImageUrl\n    id\n  }\n}\n\nfragment OrganizationDetailsPending_organization_1Bmzm5 on Query {\n  organization(id: $id) {\n    id\n    name\n    address1\n    city\n    state\n    website\n    zipcode\n    country {\n      name\n    }\n    phone\n    email\n  }\n}\n\nfragment JobHistory_statusTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ea42ad5c0e47224a8ae638c06f542d4';
module.exports = node;
